import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { PageProvider } from "@/context/PageContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesHub from "@/pages/ServicesHub";
import ServiceDetail from "@/pages/ServiceDetail";
import ProjectsHub from "@/pages/ProjectsHub";
import ProjectDetail from "@/pages/ProjectDetail";
import TechStacksHub from "@/pages/TechStacksHub";
import TechStackDetail from "@/pages/TechStackDetail";
import ToolDetail from "@/pages/ToolDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import SitemapPage from "@/pages/SitemapPage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <PageProvider>
          <Routes>
            <Route element={<Layout />}>
              {/* Danish (default) */}
              <Route path="/" element={<Home />} />
              <Route path="/om" element={<About />} />
              <Route path="/ydelser" element={<ServicesHub />} />
              <Route path="/ydelser/:slug" element={<ServiceDetail />} />
              <Route path="/projekter" element={<ProjectsHub />} />
              <Route path="/projekter/:slug" element={<ProjectDetail />} />
              <Route path="/tech-stacks" element={<TechStacksHub />} />
              <Route path="/tech-stacks/:slug" element={<TechStackDetail />} />
              <Route path="/tech-stacks/:stack/:tool" element={<ToolDetail />} />
              <Route path="/viden" element={<Blog />} />
              <Route path="/viden/:slug" element={<BlogPost />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/sitemap" element={<SitemapPage />} />

              {/* English (/en) */}
              <Route path="/en" element={<Home />} />
              <Route path="/en/about" element={<About />} />
              <Route path="/en/services" element={<ServicesHub />} />
              <Route path="/en/services/:slug" element={<ServiceDetail />} />
              <Route path="/en/projects" element={<ProjectsHub />} />
              <Route path="/en/projects/:slug" element={<ProjectDetail />} />
              <Route path="/en/tech-stacks" element={<TechStacksHub />} />
              <Route path="/en/tech-stacks/:slug" element={<TechStackDetail />} />
              <Route path="/en/tech-stacks/:stack/:tool" element={<ToolDetail />} />
              <Route path="/en/blog" element={<Blog />} />
              <Route path="/en/blog/:slug" element={<BlogPost />} />
              <Route path="/en/contact" element={<Contact />} />
              <Route path="/en/sitemap" element={<SitemapPage />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <Toaster position="bottom-right" theme="dark" richColors />
        </PageProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
